var _a;
import { createSlice } from '@reduxjs/toolkit';
export var initialState = {
    isAuthenticated: false,
    isAuthFailure: false
};
var globalAuthSlice = createSlice({
    name: 'globalAuth',
    initialState: initialState,
    reducers: {
        clearGlobalAuthState: function () {
            return initialState;
        },
        authLogin: function (state) {
            state.isAuthenticated = true;
        },
        authLogout: function (state) {
            state.isAuthenticated = false;
        }
    }
});
export var clearGlobalAuthState = (_a = globalAuthSlice.actions, _a.clearGlobalAuthState), authLogin = _a.authLogin, authLogout = _a.authLogout;
export default globalAuthSlice.reducer;
//# sourceMappingURL=globalAuth.slice.js.map